import { runApp } from "@eusoft/webapp-framework/App";
import { RmApp } from "./RmApp";

runApp(new RmApp());